module.exports = __webpack_public_path__ + "img/ask.fb3a7c48.png";